import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "standards",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "standard-insights" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [],
});
